import { storyblokEditable } from "@storyblok/react";

const PortalCard = ({ blok }) => {
  return (
    <div
      {...storyblokEditable(blok)}
      className="flex flex-col h-full w-full"
    >
      {/* Title */}
      <h3 className="text-xl font-semibold mb-4 leading-snug min-h-[3.25rem]">
        {blok.title}
      </h3>

      {/* Image */}
      {blok.image?.filename && (
        <div className="w-full overflow-hidden rounded-xl aspect-[16/9] bg-gray-100">
          <img
            src={blok.image.filename}
            alt={blok.image.alt || blok.title}
            className="h-full w-full object-cover"
          />
        </div>
      )}

      {/* Description */}
      {blok.description && (
        <p className="text-gray-600 mt-4 leading-relaxed">
          {blok.description}
        </p>
      )}
    </div>
  );
};

export default PortalCard;
